"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDevicePreview = void 0;
const ObserverList_1 = require("./ObserverList");
function makeDevicePreview() {
    return new DevicePreviewImp();
}
exports.makeDevicePreview = makeDevicePreview;
class DevicePreviewImp {
    constructor() {
        this._deviceLookup = new Map();
        this.observers = new ObserverList_1.ObserverList();
        this.setSelectedDevice = (id) => {
            var _a;
            const device = this._deviceLookup.get(id);
            if (!device) {
                console.warn(`[DevicePreview] Unable to find device by id ${id}`);
                return;
            }
            if (((_a = this._selectedDevice) === null || _a === void 0 ? void 0 : _a.id) === device.id)
                return;
            this._selectedDevice = device;
            this.observers.notify();
        };
        this.clearSelectedDevice = () => {
            if (this._selectedDevice === undefined)
                return;
            this._selectedDevice = undefined;
            this.observers.notify();
        };
        this.getCategoryList = () => {
            const categories = [];
            this._deviceLookup.forEach((device) => {
                if (!categories.includes(device.category)) {
                    categories.push(device.category);
                }
            });
            return categories;
        };
        this.getDevicesInCategory = (categoryName) => {
            const devices = [];
            this._deviceLookup.forEach((device) => {
                if (device.category === categoryName) {
                    devices.push(device);
                }
            });
            return devices;
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
    }
    get deviceList() {
        return Array.from(this._deviceLookup.values());
    }
    set deviceList(list) {
        this._deviceLookup.clear();
        list.forEach((device) => this._deviceLookup.set(device.id, device));
        this.observers.notify();
    }
    get selectedDevice() {
        return this._selectedDevice;
    }
}
